module.exports = __webpack_public_path__ + "img/cargo-ship.83141d88.svg";